import {IGenericType} from 'constants/interfaces';

export enum EActiveState {
  DELETED = 'DELETED',
  NOT_APPLIED = 'NOT_APPLIED',
  PENDING_APPROVAL = 'PENDING_APPROVAL',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  APPLICATION_NOT_FINISHED = 'APPLICATION_NOT_FINISHED',
}

export interface ISimpleProduceItem {
  buyerType?: number;
  id: number;
  name: string;
  active: number;
  packaging?: Array<IGenericType>;
  packages?: Array<IGenericType>;
  sizes?: Array<IGenericType>;
  variety?: Array<IGenericType>;
  grading?: Array<IGenericType>;
  pickoftheweek?: number;
  category?: string;
  daffDocument?: string;
  numberOfFarmers?: number;
}

export type TFarmField = {
  id: any;
  info: {
    fieldName: string;
  };
};
